import React, {  } from 'react';
import useGlobal from '../../store';
import ItemCard from '../Gift/ItemCard';
import GiftIdeas from '../General/GiftIdeas';
import EmptyGiftlist from '../General/EmptyGiftlist';

const MyGiftlist = (props) => {

    const [mygiftlist] = useGlobal(
        state => state.mygiftlist
    );

    const [user, uiActions] = useGlobal(
        state => state.user,
        actions => actions.uiActions
    );

    const items = mygiftlist.map(item => <ItemCard key={item.itemID} {...item}></ItemCard>);

    const openSidePanel = () => {
        let paramState = {
            selectedUser: user
        }
        uiActions.toggleSidePanel("additem", paramState);
    }

    return (
        <>
            {user && mygiftlist && items.length > 0 ? <></> : <EmptyGiftlist handler={openSidePanel}></EmptyGiftlist>}
            <div className="card-columns">
                {items}
            </div>
            <GiftIdeas user={user}></GiftIdeas>
        </>
    );
}
export default MyGiftlist;